import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { JSFrame } from "jsframe.js";

var lastId = 10;

class FloatingWindow extends Component {

    static jsFrame = new JSFrame();
    frame = null;

    constructor(props) {
        super(props);
        this.state = {
            width: 0,
            height: 0,
            opacity: this.props.opacity || 0.7,
            fontFamily: this.props.fontFamily || 'Caecilia'
        }

        this.id = `fw_${lastId++}`;
        this.ref = React.createRef();
        this.className = this.props.className;

        this.frame = FloatingWindow.jsFrame.create({
            title: this.props.title,
            left: this.props.left,
            top: this.props.top,
            width: this.props.size.width,
            height: this.props.size.height,
            //minWidth: 220, 
            //minHeight: 200,
            movable: true,//Enable to be moved by mouse
            resizable: true,//Enable to be resized by mouse
            appearanceName: 'material',//Preset name is 'yosemite','redstone','popup'
            appearanceParam: {
                border: {
                    shadow: '2px 2px 10px  rgba(0, 0, 0, 0.5)',
                    width: 0,
                    radius: 6,
                },
                titleBar: {
                    color: 'white',
                    background: '#0b7e7a',
                    leftMargin: 10,
                    height: 30,
                    fontSize: 14,
                    buttonWidth: 36,
                    buttonHeight: 16,
                    buttonColor: 'white',
                    buttons: [
                        {
                            fa: 'fas fa-times',
                            name: 'closeButton',
                            visible: this.props.showCloseButton
                        },
                        {
                            fa: 'fas fa-compress-arrows-alt',
                            name: 'minimizedButton',
                            visible: false
                        },
                    ],
                },
            },
            style: {
                backgroundColor: 'rgba(256,256,256,' + this.state.opacity + ')',
                overflow: 'auto'
            },
            html: '<div id="' + this.id + '" ' +
                'className="' + this.className + '" ' +
                //'ref="' + this.ref + '" ' +
                ' style="padding:10px; font-size:15px; color:black;"' +
                '>' + this.props.children + '</div>'
        });

        const titleBarTextId = this.frame.getWindowId() + '_titleBarText'
        document.getElementById(titleBarTextId).style.fontFamily = this.state.fontFamily
    }

    componentDidMount = () => {
        this.update();

        this.frame.on('closeButton', 'click', (frame, info) => {
            this.props.close()
            this.frame.hide()
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.isShow)
            this.frame.show();
        else
            this.frame.hide()

        if (this.props.size.width !== this.state.width || this.props.size.height !== this.state.height) {
            this.frame.setSize(this.props.size.width, this.props.size.height)
            this.setState({ width: this.props.size.width, height: this.props.size.height })
        }
        this.update();
    }

    componentWillUnmount = () => { }

    update = () => { ReactDOM.render(this.props.children, document.getElementById(this.id)); }

    render = () => null;

}

export default FloatingWindow;